import { render, staticRenderFns } from "./MarkdownTransfer.vue?vue&type=template&id=167288aa&"
import script from "./MarkdownTransfer.vue?vue&type=script&lang=ts&"
export * from "./MarkdownTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownTransfer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports